module.exports = __webpack_public_path__ + "assets/theme.a8c15249.svg";